<div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [fill]="chartOptions.fill"
      [legend]="chartOptions.legend"
      [plotOptions]="chartOptions.plotOptions"
      [xaxis]="chartOptions.xaxis"
    ></apx-chart>
</div>